module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow-8a2f4e8f291616105bdfcd533fef3f55.png";